import React from "react";
import { TableRow, TableCell, withStyles, withTheme } from "@material-ui/core";
import MapPopupTooltip from "./MapPopupTooltip";
import { formatPhone } from "../../../../modules/Dispatch/utils/utils";
import { compose } from "recompose";

const styles = {
  driverStatusHeadHeight: {
    height: "24px",
    color:"#444444"
  },
  driverStatusHeaderCell: {
    borderBottom: 0,
    fontSize: 12,
    paddingLeft: "10px",
    fontWeight: 600,
  },
  customerName: {
    float: "left",
    paddingLeft: "10px",
    lineHeight: "17px",
    width: "55%",
    textOverflow: "ellipsis",
    wordBreak: "break-all",
  },
  contactNumber: {
    float: "right",
    fontSize: 12,
    paddingRight: "10px",
  },
};

const Contact = ({ theme, classes, name, phoneNumber }) => {
  if (!(name || phoneNumber)) {
    return null;
  }
  const formattedPhoneNumber = formatPhone(phoneNumber);
  return (
    <TableRow
      className={`${classes.driverStatusHeadHeight} driverStatusRow-${theme.themeName}`}
    >
      <TableCell
        colSpan={2}
        className={`${classes.driverStatusHeaderCell} driverStatusRow-${theme.themeName} tableCellValue`}
      >
        <div className={classes.customerName}> {name} </div>
        <MapPopupTooltip title={formattedPhoneNumber}>
          <span className={classes.contactNumber}>{formattedPhoneNumber}</span>
        </MapPopupTooltip>
      </TableCell>
    </TableRow>
  );
};

export default compose(withStyles(styles), withTheme())(Contact);
